/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Reaction_MuscleInputs */

const en_us2_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength`)
};

const pt_br2_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const es_419_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza`)
};

const pt_pt2_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const fr_fr2_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

const de_de2_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraft`)
};

const it_it2_clubs_reaction_muscle = /** @type {(inputs: Clubs_Reaction_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza`)
};

/**
* | output |
* | --- |
* | "Strength" |
*
* @param {Clubs_Reaction_MuscleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_reaction_muscle = /** @type {((inputs?: Clubs_Reaction_MuscleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Reaction_MuscleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_reaction_muscle(inputs)
	if (locale === "es-419") return es_419_clubs_reaction_muscle(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_reaction_muscle(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_reaction_muscle(inputs)
	if (locale === "de-DE") return de_de2_clubs_reaction_muscle(inputs)
	if (locale === "it-IT") return it_it2_clubs_reaction_muscle(inputs)
	return en_us2_clubs_reaction_muscle(inputs)
});
export { clubs_reaction_muscle as "clubs.reaction_muscle" }